import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Button from './Button'

function Header(prop) {

    const [openNav, setOpenNav] = useState(false)


    const toggleNav = () => {
        setOpenNav(!openNav)
    }

    

  return (
    <div className='bg-white h-24 w-full flex'>
        
            <div className=' flex max-w-[1280px] justify-between items-center w-[90%] mx-auto relative'>
                <div>
                  <Link to ='/'>
                    <img src='./img/honors.jpg' alt='honors logo' className='w-24 h-auto'/> 
                  </Link>
                  
                </div>

                <div className={`${openNav ? 'block' : 'hidden' } h-auto px-4 py-3 z-30 self-center rounded bg-black text-white lg:text-black font-bold absolute top-0 right-0 md:right-0 flex flex-col gap-4 lg:px-0 lg:py-0 lg:bg-transparent lg:flex lg:gap-3 lg:flex-row lg:relative md:absolute`}>
                    <Link to='/' onClick={toggleNav}>Home</Link>
                    <Link to='/ourvision' onClick={toggleNav}>Our Vision</Link>
                    <Link to='/projects' onClick={toggleNav}>Projects</Link>
                </div> 
                <div className='flex items-center'>
                <div className=' w-[3rem] flex flex-col items-center gap-[.2rem] justify-center h-[4rem] cursor-pointer lg:hidden' onClick={toggleNav}>
                    <span className='bg-black block rounded-sm w-[1.3rem] h-[.2rem]' ></span>
                    <span className='bg-black block rounded-sm w-[1.3rem] h-[.2rem]' ></span>
                    <span className='bg-black block rounded-sm w-[1.3rem] h-[.2rem]' ></span>

                  </div> 
                  <Button onclick={prop.onclick} children='Donate' className='px-2 h-8 flex items-center' bgColor='bg-orange-500' bdRad='rounded-[1.2rem]' /> 
                  </div> 
                 
            </div>
                            
    </div>
  )
}

export default Header